import { NativeModules, Platform } from "react-native";
import Constants from "expo-constants";
let { Brand } = NativeModules;


class Branding {
  static getBrandName: () => string  = () => {
    // console.log("Brand", Brand);
    var result: string;
    if (!Brand || Platform.OS === "web") {
      result = Constants.manifest?.name || "Default";
    } else {
      result = Brand.getConstants().BRAND_NAME;
    }
    return result;
  };

  static getCloudServer: () => string = function () {
    if (!Brand) return "";

    var result: string = Brand.getConstants().CLOUD_SERVER;
    return result;
  };
}

export default Branding;
